var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"floating-block",class:_vm.className,style:(_vm.timeWrapperStyle)},[_c('div',{class:{fixed: _vm.fixed},style:(_vm.absoluteStyles)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }